import { Pipe, PipeTransform } from "@angular/core";
import { Data } from "../pie-chart.type";

@Pipe({ name: "getProps" })
export class GetPropsPipe implements PipeTransform {
  transform(data: Data[], prop: keyof Data): unknown {
    return data.map((d) => d[prop]);
  }
}
